/* global Hammer,site*/
(function ($, ELCHistory) {
  var $html = $('html');
  var $body = $('body');
  var isMobileLayout =
    $html.hasClass('device-mobile') || (Modernizr.touch && $(window).width() < 1024);
  var scrollFeatureBlocked = false;
  var $siteFooter = isMobileLayout ? $('.site-footer', document) : $('.site-footer--top', document);
  var $siteHeader = $('.js-site-header', document);
  var scenesEnabled = true;
  var currentSceneIndex = -1; // -1 = intro splash, 0 = splash w/ text, 1 = first grid
  var nextSceneIndex = 0; // -1 = intro splash, 0 = splash w/ text, 1 = first grid
  var nextSceneDirection = 1; // 1 for forward, -1 for backward
  var wheelDetectionBlocked = false;
  var urlGridMatchFound = false;
  var articleUrlSwitchInProgress = false;
  var hasIntroScene = true;

  // Loose hardware detection based on CPU cores
  if (!navigator.hardwareConcurrency || navigator.hardwareConcurrency < 10) {
    $html.addClass('looks-destination--low-perf');
  } else {
    $html.addClass('looks-destination--high-perf');
  }
  var ELCMacLooksPage = function ($module) {
    var self = this;

    self.$module = $module;
    self.$introSplash = $('.js-looks-destination-splash', $module);
    self.$gridsContainer = $('.js-looks-destination-grids-container', $module);
    self.$primaryCta = $('.js-looks-destination-primary-grid-cta', $module);
    self.$grids = $('.js-looks-destination-grid-wrapper', $module);
    self.$panel = $('.js-looks-grid-panel-display', $module);
    self.$list = $('.js-looks-grid-list', $module);
    self.$title = $('.js-active-grid-label', $module);
    self.setFirstSceneIndex();
    self.currentMobilePage = 1;
    self.scenesController;
    self.introScene;
    self.backgroundScene;
    self.scenesDisabledOnArticleOpen = [];
    self.macLooksGridObjectCollection = {};
    self.activeMacLooksGridIndex = 0;
    self.activeMacLooksGridObject = false;
    self.transitionEndTimeoutHolder;
    self.scenesTransitionTimeoutHolder;
    $(document).on('ELCMacLooksGrids.ready', function (event, macLooksGridObjectCollection) {
      if (!macLooksGridObjectCollection.length && currentSceneIndex < 1) {
        self.$module.addClass('content-block-state--intro');

        return false;
      }
      self.macLooksGridObjectCollection = macLooksGridObjectCollection;
      self.activeMacLooksGridObject = macLooksGridObjectCollection[self.activeMacLooksGridIndex];
      self.renderNavigation();
      self.setupEventListeners();
      $html.addClass('looks-destination-full-no-scroll');
      self.parseURLForRendering();
      self.render();
      if (!hasIntroScene && currentSceneIndex < 1) {
        self.hideIntroAndRevealGrid(true);
      }
    });
  };

  ELCMacLooksPage.prototype.setFirstSceneIndex = function () {
    var self = this;

    if (
      !!self.$introSplash.data('loadOption') &&
      self.$introSplash.data('loadOption') !== 'always'
    ) {
      var loadOption = self.$introSplash.data('loadOption');
      if (
        (isMobileLayout && loadOption === 'mobile_only') ||
        (!isMobileLayout && loadOption === 'pc_only')
      ) {
        self.$introSplash.removeClass('hidden');
        currentSceneIndex = -1;
        hasIntroScene = true;
      }
      if (
        (!isMobileLayout && loadOption === 'mobile_only') ||
        (isMobileLayout && loadOption === 'pc_only')
      ) {
        currentSceneIndex = 0;
        nextSceneIndex = 1;
        hasIntroScene = false;
      }
    } else {
      self.$introSplash.removeClass('hidden');
    }
  };

  ELCMacLooksPage.prototype.analyticsEvtLink = function (analyticsObject) {
    if (site && site.track && site.track.evtLink) {
      setTimeout(function () {
        site.track.evtLink(analyticsObject);
      }, 1);
    }
  };

  ELCMacLooksPage.prototype.analyticsEvtView = function (analyticsObject) {
    if (site && site.track && site.track.evtView) {
      setTimeout(function () {
        site.track.evtView(analyticsObject);
      }, 1);
    }
  };

  ELCMacLooksPage.prototype.fixScrollTop = function () {
    $('*').scrollTop(0);
  };
  ELCMacLooksPage.prototype.pauseScenes = function () {
    if (isMobileLayout) {
      return false;
    }
    scenesEnabled = false;
  };

  ELCMacLooksPage.prototype.enableScenes = function () {
    if (isMobileLayout) {
      return false;
    }
    scenesEnabled = true;
  };

  ELCMacLooksPage.prototype.setupEventListeners = function () {
    var self = this;

    $(document)
      .off('keydown.looksDestinationPageFixTop')
      .on('keydown.looksDestinationPageFixTop', function (event) {
        if (event.key === 'Escape' && !$html.hasClass('looks-destination-full-article-view')) {
          self.fixScrollTop();
          event.stopPropagation();
        }
      });
    self.$primaryCta.off('click.firstArticleOpen').on('click.firstArticleOpen', function () {
      self.activeMacLooksGridObject.$articles.first().trigger('open.withoutAnimation');
    });
    $(window).on(
      'resize',
      _.debounce(function () {
        self.calculateGridScrollPoints();
      }, 300)
    );
    $(document).on(
      'ELCMacLooksGridOverlay.opened ELCMacLooksGridOverlay.rotateArticle',
      function (event, $article) {
        self.pauseScenes();
        if (isMobileLayout) {
          self.fixScrollTop();
        }
        self.$module.addClass('zoomed-in-article');
        self.$module.removeClass('zoomed-out-article');
        ELCHistory.replaceState(false, false, $article.data('permalink'));
      }
    );
    $(document).on('ELCMacLooksPage.pause', function () {
      if (self.scenesTransitionTimeoutHolder) {
        clearTimeout(self.scenesTransitionTimeoutHolder);
      }
      self.pauseScenes();
    });
    $(document).on('ELCMacLooksGridOverlay.closed', function () {
      self.pauseScenes();
      requestAnimationFrame(function () {
        $html.addClass('looks-destination-full-no-scroll');
        requestAnimationFrame(function () {
          setTimeout(function () {
            self.$module.addClass('zoomed-out-article');
            self.$module.removeClass('zoomed-in-article');
            ELCHistory.replaceState(false, false, self.activeMacLooksGridObject.getPermalink());
            if (self.scenesTransitionTimeoutHolder) {
              clearTimeout(self.scenesTransitionTimeoutHolder);
            }
            self.render();
            self.$module.find('.looks-destination__content').scrollTo(0);
            self.fixScrollTop();
            self.scenesTransitionTimeoutHolder = setTimeout(function () {
              self.toggleScrollFeatureAllowed(false);
              if (isMobileLayout) {
                self.fixScrollTop();
              } else {
                scenesEnabled = true;
              }
              self.enableScenes();
            }, 1000);
          }, 1);
        });
      });
    });
    if (isMobileLayout) {
      self.setupTouchIntroInteraction();
      self.setupTouchGridInteraction();
    } else {
      self.setupScrollInteraction();
    }
    self.$introSplash
      .find('.js-looks-destination-splash-intro-cta .js-elc-button')
      .off('click.reveal')
      .on('click.reveal', function (event) {
        event.preventDefault();
        self.hideIntroAndRevealGrid();
      });
    self.$introSplash
      .find('.looks-destination-splash__cta .js-elc-button')
      .off('click.reveal')
      .on('click.reveal', function (event) {
        event.preventDefault();
        self.setNextScrollState(0, 1);
        self.renderScrollState();
      });
  };

  ELCMacLooksPage.prototype.setNextScrollState = function (nextIndex, direction) {
    var self = this;
    var isSameScene = nextIndex === currentSceneIndex;
    // If next index is greater than the grids PLUS footer section
    var isPastFooter = nextIndex > self.$grids.length + 1;
    var isAtIntro = nextIndex < -1;

    if (isSameScene || isPastFooter || isAtIntro) {
      return false;
    }
    nextSceneIndex = nextIndex;
    nextSceneDirection = direction;
  };

  ELCMacLooksPage.prototype.renderScrollState = function () {
    var self = this;
    var timeoutBlocked = 1500;

    if (nextSceneIndex === currentSceneIndex) {
      return false;
    }
    switch (nextSceneIndex) {
      case -1:
        if (!hasIntroScene) {
          break;
        }
        self.fixScrollTop();
        requestAnimationFrame(function () {
          self.$module.addClass('scene--intro');
          self.$module.removeClass('scene--grid');
          self.$introSplash.addClass('looks-destination-splash--scene-start');
        });
        ELCHistory.replaceState('', '', ' ');
        break;
      case 0:
        if (!hasIntroScene) {
          break;
        }
        self.fixScrollTop();
        if (nextSceneDirection < 0) {
          requestAnimationFrame(function () {
            self.$module.removeClass('scene--grid');
            self.$module.addClass('scene--intro');
          });
          ELCHistory.replaceState('', '', ' ');
        } else {
          self.analyticsEvtLink({
            event_name: 'maclooks',
            event_category: 'looks destination',
            event_action: 'swipe up to explore',
            event_label: 'scroll'
          });
        }
        requestAnimationFrame(function () {
          self.$introSplash.removeClass('looks-destination-splash--scene-start');
        });
        break;
      default:
        if (nextSceneIndex === 1) {
          if (nextSceneDirection > 0) {
            requestAnimationFrame(function () {
              self.$module.addClass('scene--grid');
              self.$module.removeClass('scene--intro');
            });
          }
        }
        if (nextSceneIndex > self.$grids.length) {
          $body.animate({ scrollTop: $siteFooter.offset().top }, 600);
          timeoutBlocked = 600;
        } else if (nextSceneIndex === self.$grids.length && nextSceneDirection < 0) {
          $body.animate({ scrollTop: '0px' }, 600);
          timeoutBlocked = 600;
        } else {
          var gridIndex = nextSceneIndex - 1;
          self.setActiveGrid(gridIndex);
          self.scrollToActiveGrid();
          self.fixScrollTop();
        }
        break;
    }

    currentSceneIndex = nextSceneIndex;
    self.render();
    self.wheelDetectionToggle(timeoutBlocked);
  };

  ELCMacLooksPage.prototype.wheelDetectionToggle = function (timeoutBlocked) {
    wheelDetectionBlocked = true;
    setTimeout(function () {
      wheelDetectionBlocked = false;
    }, timeoutBlocked);
  };

  ELCMacLooksPage.prototype.setupScrollInteraction = function () {
    var self = this;
    var hammertimeCallbackInFlight = false;
    var hammertimeCallback = function (event) {
      if (hammertimeCallbackInFlight || $html.hasClass('looks-destination-full-article-view')) {
        return false;
      }
      hammertimeCallbackInFlight = true;
      var direction = event.deltaY * -1 > 0 ? 1 : -1;
      var nextSceneParam = direction > 0 ? currentSceneIndex + 1 : currentSceneIndex - 1;

      self.setNextScrollState(nextSceneParam, direction);
      self.renderScrollState();
      setTimeout(function () {
        hammertimeCallbackInFlight = false;
      }, 10);
    };

    if (Modernizr.touch) {
      var hammertime = new Hammer(self.$module[0]);
      var hammertime2 = new Hammer($body[0]);

      hammertime.get('pan').set({
        direction: Hammer.DIRECTION_VERTICAL
      });
      hammertime2.get('pan').set({
        direction: Hammer.DIRECTION_VERTICAL
      });
      hammertime.on('panend', hammertimeCallback);
      hammertime2.on('panend', hammertimeCallback);
    } else {
      $(window).on(
        'wheel.looksIntro',
        _.throttle(function (event) {
          if (!wheelDetectionBlocked && scenesEnabled) {
            if (event.originalEvent.deltaY > 0) {
              self.setNextScrollState(currentSceneIndex + 1, 1);
            } else if (hasIntroScene || currentSceneIndex > 1) {
              self.setNextScrollState(currentSceneIndex - 1, -1);
            } else {
              self.wheelDetectionToggle(600);
            }
            self.renderScrollState();
          }
        }, 10)
      );
    }
  };

  ELCMacLooksPage.prototype.renderNavigation = function () {
    var self = this;
    var throttledAction = _.throttle(function (parentIndex) {
      self.render();
      self.setActiveGrid(parentIndex);
      self.scrollToActiveGrid(false);
    }, 1300);

    // Render menu list
    self.$list.html('');
    for (var gridKey in self.macLooksGridObjectCollection) {
      self.$list.append(
        '<li><a href="' +
          self.macLooksGridObjectCollection[gridKey].getPermalink() +
          '">' +
          self.macLooksGridObjectCollection[gridKey].getLabel() +
          '</a></li>'
      );
    }
    self.$list.off('click.change').on('click.change', 'a', function (e) {
      if ($(this).hasClass('active') || self.$module.hasClass('zoomed-in-article')) {
        return false;
      }
      var parentIndex = $(this).parent().index();

      e.preventDefault();
      throttledAction.call(this, parentIndex);
    });
  };

  // Make sure there's an active grid
  // Render the panel and go to that active grid
  ELCMacLooksPage.prototype.render = function () {
    var self = this;

    if (isMobileLayout) {
      var $targetsToHide = self.$grids.find('.js-looks-destination-sidebar-headline');
      var $targetsToShow = self.$grids
        .eq(self.activeMacLooksGridIndex)
        .find('.js-looks-destination-sidebar-headline');

      setTimeout(function () {
        $targetsToHide.not($targetsToShow).addClass('slide-out').removeClass('slide-in');
        $targetsToShow
          .css({
            transition: 'all 0s'
          })
          .addClass('slide-out')
          .removeClass('slide-in');
        setTimeout(function () {
          $targetsToShow.css({
            transition: ''
          });
          setTimeout(function () {
            $targetsToShow.addClass('slide-in').removeClass('slide-out');
          }, 800);
        }, 1);
      }, 1);
    } else {
      var $targets = self.$panel;
      var slideTransitionTimeoutHolder;
      var transitionTime = (function () {
        if (currentSceneIndex < 1 && nextSceneDirection > 0) {
          return 0;
        }

        return 1000;
      })();
      var updateSlideElement = function () {
        self.$title.attr(
          'aria-title',
          self.macLooksGridObjectCollection[self.activeMacLooksGridIndex].getLabel()
        );
        $targets.addClass('slide-in').removeClass('slide-out');
      };

      requestAnimationFrame(function () {
        if (!hasIntroScene && currentSceneIndex < 1) {
          return;
        }
        $targets.addClass('slide-out').removeClass('slide-in');
        if (slideTransitionTimeoutHolder) {
          clearTimeout(slideTransitionTimeoutHolder);
        }
        slideTransitionTimeoutHolder = setTimeout(function () {
          // If we are not at a scene, dont do anything
          if (currentSceneIndex >= 1 && nextSceneDirection) {
            updateSlideElement();
          }
        }, transitionTime);
      });
    }
    requestAnimationFrame(function () {
      if (!hasIntroScene && currentSceneIndex < 1) {
        return;
      }
      self.$grids.removeClass('active');
      self.$list.children().removeClass('active');
      self.$list.children().eq(self.activeMacLooksGridIndex).addClass('active');
      self.$grids.eq(self.activeMacLooksGridIndex).addClass('active');
    });
  };

  ELCMacLooksPage.prototype.scrollToActiveGrid = function (dontAnimate) {
    var self = this;
    requestAnimationFrame(function () {
      var translateYNew = self.getOffsetRelativeToGrid(
        self.$grids.eq(self.activeMacLooksGridIndex)
      );

      self.$grids.eq(self.activeMacLooksGridIndex).attr('style', '');
      self.scrollGridsContainer(-1 * translateYNew + 'px', dontAnimate);
    });
    if (!dontAnimate && !articleUrlSwitchInProgress && !urlGridMatchFound) {
      self.analyticsEvtView({
        page_url: self.activeMacLooksGridObject.getPermalink()
      });
      $(document).trigger('ELCMacLooksPage.touchGridScrollTranslateY');
      ELCHistory.replaceState(false, false, self.activeMacLooksGridObject.getPermalink());
    }
  };

  ELCMacLooksPage.prototype.getOffsetRelativeToGrid = function ($element) {
    var self = this;
    var elemHeight = $element.length > 0 ? $element.offset().top : 0;
    var calculatedOffset = Math.abs(self.$gridsContainer.offset().top - elemHeight);
    return calculatedOffset;
  };

  ELCMacLooksPage.prototype.setupTouchIntroInteraction = function () {
    var self = this;
    var hammertime = new Hammer($('.js-looks-destination-splash', self.$module)[0]);

    hammertime.get('pan').set({
      direction: Hammer.DIRECTION_UP
    });
    self.$introSplash.parent().css({
      transition: 'transform 1s'
    });
    hammertime
      .on('pan', function (event) {
        var dragPercentage = Math.round((event.deltaY / $(window).height()) * 0.5 * 100);

        self.$introSplash.parent().css({
          transform: 'translateY( ' + dragPercentage + '%)'
        });
      })
      .on('panend', function (event) {
        if (event.deltaY * -1 > $(window).height() * 0.12) {
          self.hideIntroAndRevealGrid();
          self.analyticsEvtLink({
            event_name: 'maclooks',
            event_category: 'looks destination',
            event_action: 'swipe up to explore',
            event_label: 'swipe'
          });
        } else {
          self.$introSplash.parent().css({
            transition: 'transform .45s ease-out',
            transform: 'translateY(0)'
          });
        }
      });
  };

  ELCMacLooksPage.prototype.calculateGridScrollPoints = function () {
    if (!isMobileLayout) {
      return false;
    }
    var self = this;

    requestAnimationFrame(function () {
      self.$grids.each(function () {
        var $this = $(this);

        $this.attr('data-translateY1', -1 * self.getOffsetRelativeToGrid($this) + 'px');
        $this.attr(
          'data-translateY2',
          -1 *
            self.getOffsetRelativeToGrid(
              $this.find('.js-looks-destination-article-mobile-article-scrollpoint')
            ) +
            'px'
        );
      });
    });
  };

  ELCMacLooksPage.prototype.hideIntroAndRevealGrid = function (dontAnimate) {
    var self = this;

    if (isMobileLayout) {
      $html.removeClass('looks-destination-page--intro-state');
      self.$introSplash.parent().css({
        transition: 'transform ' + (dontAnimate ? '0.01s' : '.45s') + ' ease-out',
        transform: 'scale(0.9) translateY(-110%)'
      });
      self.$module.addClass('looks-destination-state--intro-revealed');
      if (!articleUrlSwitchInProgress && !urlGridMatchFound) {
        self.render();
        self.setActiveGrid(0);
        self.scrollToActiveGrid(dontAnimate);
      }
      $(document).scrollTop(0);
      self.calculateGridScrollPoints();
    } else {
      self.setNextScrollState(1, 1);
      self.renderScrollState();
    }
    if (!dontAnimate) {
      ELCHistory.replaceState(false, false, self.activeMacLooksGridObject.getPermalink());
    }
  };

  ELCMacLooksPage.prototype.exitGridAndBackToIntro = function () {
    var self = this;

    $html.addClass('looks-destination-page--intro-state');
    if (isMobileLayout) {
      self.$introSplash.parent().css({
        transition: 'transform 0s',
        transform: 'scale(0.9) translateY(-110%)'
      });
      setTimeout(function () {
        self.$introSplash.parent().css({
          transition: 'transform 1s',
          transform: 'scale(1) translateY(0%)'
        });
      }, 1);
    } else {
      self.$introSplash.parent().css({
        transition: 'transform 1s',
        transform: 'scale(1) translateY(0%)'
      });
    }
    self.$module.removeClass('looks-destination-state--intro-revealed');
    self.$introSplash.off('transitionend.reveal');
    ELCHistory.replaceState(false, false, ' ');
  };

  ELCMacLooksPage.prototype.scrollGridsContainer = function (translateY, dontAnimate) {
    var self = this;
    var animationTimeValue = isMobileLayout ? '1s' : '1.7s';

    requestAnimationFrame(function () {
      self.$gridsContainer.css({
        transition: 'transform ' + (dontAnimate ? '0.01s' : animationTimeValue),
        transform: 'translateY( ' + translateY + ')'
      });
    });
  };

  ELCMacLooksPage.prototype.calculateAndPanToNextStickyPoint = function (eventDeltaY) {
    var self = this;
    // This is a negative offset of the amount being pulled up
    var newPosition = self.$gridsContainer.offset().top + eventDeltaY;

    self.calculateGridScrollPoints();
    // Negative delta means we're pulling the layout back in, so we are going backwards
    if (eventDeltaY >= 0) {
      // When we are scrolling up, scroll the grid in sticky sections
      // 1. If the next position is GREATER than the midpoint article, next position is midpoint article
      // 2. Else if the next position is GREATER than the grid, next position is the top of the grid
      // 3. Otherwise the next position is the midway point of the previous grid and trigger grid change
      if (!this.macLooksGridObjectCollection[self.activeMacLooksGridIndex - 1]) {
        if (newPosition >= $(window).height() * 0.05) {
          self.exitGridAndBackToIntro();
          self.render();
        } else {
          if (
            newPosition >=
            self.getOffsetRelativeToGrid(
              this.activeMacLooksGridObject.$grid.find(
                '.js-looks-destination-article-mobile-article-scrollpoint'
              )
            )
          ) {
            self.currentMobilePage = self.activeMacLooksGridIndex + 0.5;
          } else {
            self.currentMobilePage = self.activeMacLooksGridIndex;
          }
        }
      } else {
        if (
          Math.abs(newPosition) <=
          self.getOffsetRelativeToGrid(this.activeMacLooksGridObject.$gridWrapper)
        ) {
          self.setActiveGrid(this.activeMacLooksGridIndex - 1);
          self.render();
          if (
            isMobileLayout &&
            Math.abs(newPosition) >=
              self.getOffsetRelativeToGrid(
                this.activeMacLooksGridObject.$grid.find(
                  '.js-looks-destination-article-mobile-article-scrollpoint'
                )
              )
          ) {
            self.currentMobilePage = this.activeMacLooksGridIndex + 0.5;
          }
        } else {
          if (
            isMobileLayout &&
            newPosition <= 0 &&
            Math.abs(newPosition) >=
              self.getOffsetRelativeToGrid(
                this.activeMacLooksGridObject.$grid.find(
                  '.js-looks-destination-article-mobile-article-scrollpoint'
                )
              )
          ) {
            self.currentMobilePage = this.activeMacLooksGridIndex + 0.5;
          } else {
            self.currentMobilePage = this.activeMacLooksGridIndex;
          }
        }
      }
    } else {
      // When we are scrolling down
      // 1. If the next position is GREATER than the midpoint article, next position is next grid
      // 2. Else next position is the midpoint article

      if (
        Math.abs(newPosition) >=
        self.getOffsetRelativeToGrid(
          this.activeMacLooksGridObject.$grid.find(
            '.js-looks-destination-article-mobile-article-scrollpoint'
          )
        )
      ) {
        if (this.macLooksGridObjectCollection[this.activeMacLooksGridIndex + 1]) {
          self.setActiveGrid(this.activeMacLooksGridIndex + 1);
          self.render();
        } else {
          self.currentMobilePage = this.activeMacLooksGridIndex + 1;
        }
      } else if (
        Math.abs(newPosition) >=
        self.getOffsetRelativeToGrid(this.activeMacLooksGridObject.$gridWrapper)
      ) {
        self.currentMobilePage = this.activeMacLooksGridIndex + 0.5;
      } else {
        self.currentMobilePage = this.activeMacLooksGridIndex;
      }
    }
    if (self.currentMobilePage % 1 === 0.5) {
      newPosition = self.activeMacLooksGridObject.$gridWrapper.attr('data-translateY2');
    } else {
      newPosition = self.activeMacLooksGridObject.$gridWrapper.attr('data-translateY1');
    }
    if (this.macLooksGridObjectCollection[Math.floor(self.currentMobilePage)]) {
      self.$gridsContainer.attr('data-active-translateY', newPosition);
      self.scrollGridsContainer(newPosition);
    } else {
      $body.animate({ scrollTop: $siteFooter.offset().top - $siteHeader.height() }, 750);
      $(document).trigger('ELCMacLooksPage.enterFooter');
    }

    return newPosition;
  };

  ELCMacLooksPage.prototype.setupTouchGridInteraction = function () {
    var self = this;
    var hammertime = new Hammer(self.$gridsContainer[0]);

    hammertime.get('pan').set({ direction: Hammer.DIRECTION_VERTICAL });
    hammertime.on('panend', function (event) {
      if (scrollFeatureBlocked || self.$module.hasClass('zoomed-in-article')) {
        return false;
      }
      $(document).trigger('ELCMacLooksPage.touchGridScrollTranslateY');
      self.calculateAndPanToNextStickyPoint(event.deltaY);
    });
    $siteFooter.off('scroll.looksFooter').on('scroll.looksFooter', function () {
      if ($(this).scrollTop() < -50) {
        $body.stop().animate({ scrollTop: 0 }, 750);
        hammertime.get('pan').set({ enable: true });
      }
    });
    $(document).on('ELCMacLooksPage.enterFooter', function () {
      hammertime.get('pan').set({ enable: false });
    });
  };

  ELCMacLooksPage.prototype.toggleScrollFeatureAllowed = function (disable) {
    scrollFeatureBlocked = !!disable;
  };

  ELCMacLooksPage.prototype.lazyloadGridImage = function ($grid) {
    $grid.find('.js-looks-destination-lazyload').each(function () {
      $(this).removeClass('js-looks-destination-lazyload looks-destination-lazyload');
      $(this).attr('src', $(this).data('src'));
    });
  };

  ELCMacLooksPage.prototype.setActiveGrid = function (index) {
    var self = this;
    var sameIndex = index === this.activeMacLooksGridIndex;
    var $grid = self.$grids.eq(index);

    if (!(this.macLooksGridObjectCollection[index] && $grid.length)) {
      return false;
    }
    self.lazyloadGridImage($grid);
    setTimeout(function () {
      self.lazyloadGridImage(self.$grids);
    }, 1000);
    this.currentMobilePage = index;
    this.activeMacLooksGridIndex = index;
    currentSceneIndex = 1 + index;
    this.activeMacLooksGridObject = this.macLooksGridObjectCollection[index];
    if (isMobileLayout) {
      this.render(sameIndex);
    }
  };

  ELCMacLooksPage.prototype.parseURLForRendering = function () {
    var self = this;
    var urlParameters = location.pathname;

    // If we have a window location hash, this is the old URL system
    if (window.location.hash) {
      urlParameters += window.location.hash;
    }
    if (urlParameters.split('?').length > 1) {
      urlParameters = urlParameters.split('?')[0];
    }
    var $matchedGrid = self.$grids.filter('[data-permalink="' + urlParameters + '"]');

    if ($matchedGrid.length) {
      urlGridMatchFound = true;
      self.hideIntroAndRevealGrid(true);
      // we plus one $matchedGrid.index() because the first grid scene is 1
      if (isMobileLayout) {
        self.setActiveGrid($matchedGrid.index());
        self.scrollToActiveGrid(false);
        urlGridMatchFound = false;
      } else {
        nextSceneIndex = $matchedGrid.index() + 1;
        setTimeout(function () {
          self.scrollToActiveGrid(false);
          self.renderScrollState();
          urlGridMatchFound = false;
        }, 100);
      }
    } else {
      var $matchedArticle = self.$grids.find(
        '.js-looks-destination-article[data-permalink="' + urlParameters + '"]'
      );

      if ($matchedArticle.length) {
        articleUrlSwitchInProgress = true;
        urlGridMatchFound = true;
        self.hideIntroAndRevealGrid(true);
        self.setActiveGrid($matchedArticle.closest('.js-looks-destination-grid-wrapper').index());
        self.scrollToActiveGrid(false);
        if (isMobileLayout) {
          requestAnimationFrame(function () {
            setTimeout(function () {
              articleUrlSwitchInProgress = false;
              $matchedArticle.trigger('open.withoutAnimation');
            }, 1400);
          });
        } else {
          nextSceneIndex =
            $matchedArticle.closest('.js-looks-destination-grid-wrapper').index() + 1;
          self.renderScrollState();
          setTimeout(function () {
            $matchedArticle.trigger('click.articleOpen');
          }, 1);
        }
      }
    }
  };

  var $modules = $('.js-looks-destination-page-formatter--v1', $body);

  $modules.each(function () {
    new ELCMacLooksPage($(this));
  });
  requestAnimationFrame(function () {
    $html.addClass('looks-destination-page');
  });
})(jQuery, window.ELCHistory || {});
